import { TriState } from "./Enums";

export class RegionSearchParameters {
    pageNumber: number = 0;
    buyerIDs: Array<number> = [];
    searchText: string = "";
    isDeleted: TriState = TriState.UseDefault;

    get showDeleted(): boolean {
        return this.isDeleted !== TriState.False;
    }
    set showDeleted(value: boolean) {
        this.isDeleted = value ? TriState.UseDefault : TriState.False;
    }
}